import { putRequest } from '../api-handler';
import { UserDto } from './user';

export const UserApi = {
  edit: (id: number, user: UserDto) => putRequest<UserDto>(`/users/${id}`, user)
};
